<div class="aui-page-panel" style="padding-right: 1px">
  <div class="aui-page-panel-inner">
    <section class="aui-page-panel-content" style="padding-left: 0; padding-right: 0; padding-top: 0">
      <div class="aui-toolbar2">
        <div class="aui-toolbar2-inner">
          <div class="aui-toolbar2-primary">
            <div id="button-set2" class="aui-buttons">
              <!-- <button (click)="reload()">refresh</button> -->
              <app-button
                [disabled]="!me"
                [iconType]="IconTypes.Configure"
                [id]="'manage-token-btn'"
                [btnTitle]="'Manage your Hubstaff account'"
                (clickHandler)="showManaageAccount()"
              >
                Hubstaff auth
              </app-button>
              <!-- <app-button
                *ngIf="!showUserActivities"
                [id]="'user-activities-btn'"
                [btnTitle]="'View recent users activities for this issue'"
                [iconType]="IconTypes.Group"
                (clickHandler)="loadUserActivities()"
                [disabled]="me === null"
              >
                Users activity
              </app-button> -->
              <!-- <span class="aui-icon aui-icon-small aui-iconfont-arrow-left-circle">Insert meaningful text here for accessibility</span> -->
              <!-- <app-button
                [iconType]="IconTypes.ArrowLeftCircle"
                [id]="'back-to-timer-btn'"
                [btnTitle]="'Back to the timer'"
                *ngIf="showUserActivities"
                (clickHandler)="hideUserActivities()"
              >
                Back
              </app-button> -->
            </div>
          </div>
          <div class="aui-toolbar2-secondary">
            <div class="aui-buttons"></div>
            <div id="button-set2" class="aui-buttons">
              <button
                class="aui-button aui-dropdown2-trigger aui-dropdown2-trigger-arrowless"
                aria-controls="dropdown-button-split"
              >
                <span class="aui-icon aui-icon-small aui-iconfont-more" aria-hidden="true"></span>
              </button>
              <div
                id="dropdown-button-split"
                class="aui-dropdown2 aui-layer"
                data-aui-alignment-container="#button-set2"
              >
                <ul>
                  <li>
                    <a href="https://app.hubstaff.com" target="_blank"
                      ><img
                        width="16px"
                        height="16px"
                        style="vertical-align: middle"
                        src="/img/hubstaff_icon.png"
                        alt=""
                        title=""
                      />
                      hubstaff.com</a
                    >
                  </li>
                  <!-- <li>
                    <a href="#"><app-icon [type]="IconTypesEnum.Configure"></app-icon> Project settings</a>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-container *ngIf="loaded; else loadingSpinner">
  <div *ngIf="!isSyncMe && !showHubstaffAccount && me?.id === 'no-id'" class="p-top-10">
    <app-message [title]="'Auth not finished'" [type]="'warning'">
      <span
        >Looks like you Hubstaff sync was not fully completed. Click "Hubstaff auth" to remove account and try sync
        again.
      </span>
    </app-message>
  </div>
  <div class="auth-btn-handler" *ngIf="!me && !isSyncMe">
    <a
      href="{{ authUrl || '#' }}"
      target="_blank"
      (click)="handleAuthCheck()"
      class="aui-button aui-button-primary auth-btn"
      >Authorise with Hubstaff</a
    >
  </div>

  <app-hubstaff-account
    [me]="me"
    *ngIf="showHubstaffAccount"
    (removeHandler)="removeToken($event)"
    (cancelHandler)="hideManageAccount()"
  ></app-hubstaff-account>

  <ng-container *ngIf="isSyncMe">
    <div class="aui-group spinner-center">
      <p>Sync Hubstaff user with Jira...</p>
      <app-spinner></app-spinner>
    </div>
  </ng-container>
  <!-- <app-user-activities *ngIf="showUserActivities" [me]="me" [issueKey]="issueKey"></app-user-activities> -->

  <app-issue-details
    *ngIf="me && me?.id !== 'no-id' && !showHubstaffAccount"
    [me]="me"
    [issueKey]="issueKey"
  ></app-issue-details>
</ng-container>

<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <app-spinner></app-spinner>
  </div>
</ng-template>
